module.exports = __webpack_public_path__ + "img/on-horse.24f9813a.jpg";